export const PRODUCT_NAME = 'Actalume';
export const PRODUCT_LINE = 'Every action leaves a record.';
export const PRODUCT_CATEGORY = 'The human-governed system of record for agent work.';
export const PRODUCT_DESCRIPTOR = 'The evidence layer for agentic work.';
export const APP_VERSION = '0.5.0';
